import {
  appsBomApiGetProject,
  appsBomApiListProjects,
  getAppsBomApiGetProjectQueryKey,
  getAppsBomApiListProjectsQueryKey,
} from '@/lib/api/generated/endpoints'
import type { ProjectSchema } from '@/lib/api/generated/types.ts/projectSchema'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

/**
 * Backend contract (apps/bom/api.py):
 *  - GET /api/projects → bare `list[ProjectSchema]` (no pagination — admin-managed, small dataset).
 *  - GET /api/projects/{id} → bare `ProjectSchema`.
 *
 * Cache keys re-use orval-generated factories so future generated hooks
 * sharing the same endpoint hit the same cache slot.
 */

export const projectsListQuery = () =>
  typedSuspenseOptions<readonly ProjectSchema[]>({
    queryKey: getAppsBomApiListProjectsQueryKey(),
    queryFn: ({ signal }) => appsBomApiListProjects({ signal }),
    staleTime: 30_000,
  })

export const projectQuery = (projectId: number) =>
  typedSuspenseOptions<ProjectSchema>({
    queryKey: getAppsBomApiGetProjectQueryKey(projectId),
    queryFn: ({ signal }) => appsBomApiGetProject(projectId, { signal }),
    staleTime: 30_000,
  })
